import { render } from "./QUploaderInput.vue?vue&type=template&id=6ec3fa36"
import script from "./QUploaderInput.vue?vue&type=script&lang=js"
export * from "./QUploaderInput.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ProjektetRentaCar\\rentespz\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QUploader from 'quasar/src/components/uploader/QUploader.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QUploader,QList,QItem,QItemSection,QItemLabel,QBtn,QChip,QAvatar});
